/* ====================================================================
   COMPETITION SHAPE HELPERS

   Questions about a competition that more than one screen asks, kept in
   one place so they cannot drift apart between the two.
   ==================================================================== */

/* Teams the draw builds, not teams the players bring. */
export const AUTO_TEAM_ASSIGNMENTS = ['auto-random', 'auto-rated'];

export const compBuildsTeamsFromDraw = comp =>
  AUTO_TEAM_ASSIGNMENTS.includes(String((comp && comp.teamAssignment) || ''));

/**
 * Does this competition want a team at registration time?
 *
 * A triples competition needs three players on a rink, but that is not the
 * same as needing three names on the entry form. Where the club has set
 * teams to be drawn — auto-random or auto-rated — players enter one at a
 * time and the draw groups them, so asking the first one to nominate two
 * team-mates is asking for something the club has said it will decide
 * itself, and it blocked entry to those competitions entirely.
 */
export const compTakesTeamEntries = comp =>
  Number((comp && comp.playersPerTeam) || 1) > 1 && !compBuildsTeamsFromDraw(comp);
